import React from 'react';
import ModalWindows from './components/ModalWindows/ModalWindows';
import TeasersState from './teasersState/TeasersState';
import TeasersControlPanel from './components/TeasersControlPanel/TeasersControlPanel';
import Teasers from './components/Teasers/Teasers';
import style from './index.module.scss';

const TeasersPage: React.FC = () => {
	return (
		<TeasersState>
			<div className={style.container} data-test="TeasersPage">
				<TeasersControlPanel />
				<Teasers />
				<ModalWindows />
			</div>
		</TeasersState>
	);
};

export default TeasersPage;
